import axios from 'axios'
import Variables from './global'
import { use } from './Helpers.js'

const Header=()=> {
  if (!use.token()) {
    //window.location.href='/login'
  }
  return {
    headers: {
      Authorization: use.token() ? `Bearer ${use.token()}` : ``,
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }
}

const formQuery = args => {
  let keyValues = []
  Object.keys(args).forEach((arg, index) => {
    if (
      !['', undefined, null, []].includes(
        typeof args[arg] === 'string' ? args[arg].trim() : args[arg]
      )
    ) {
      keyValues.push(`${arg}=${args[arg]}`)
    }
  })
  return keyValues.length ? `?${keyValues.join('&')}` : ''
}

const Http = async (
  methodType,
  controller,
  action,
  parameters = null,
  headers = {}
) => {
  let response = await axios({
    method: methodType,
    url: `${Variables.api_url}/${controller}/${action}${
      methodType == 'get' ? formQuery(parameters) : ''
    }`,
    headers: Object.assign(Header().headers, headers),
    data: ['put', 'post'].includes(methodType) ? parameters : null
  })
  if(response.data?.statusCode == 401){
    //return window.location.href='/login'
  }

  return response.data
}

export const call = {
  user: {
    login: parameters => Http('post', 'Auth', 'Login', parameters),
    logout: parameters => Http('post', 'Auth', 'Logout', parameters),
    checkToken: parameters => Http('post', 'Auth', 'CheckToken', parameters)
  },
  forLoggedUser: {
    course: {
      getCourses: parameters => Http('get', 'Course', 'Get', parameters),
      getCourseById: parameters => Http('get', 'Course', 'GetById', parameters),
      addCourse: parameters => Http('post', 'Course', 'Add', parameters),
      updateCourse: parameters => Http('put', 'Course', 'Edit', parameters),
      deleteCourse: parameters => Http('put', 'Course', 'Delete', parameters),
      getPriceList: parameters =>
        Http('get', 'Course', 'GetPriceList', parameters),
      editPriceList: parameters =>
        Http('put', 'Course', 'EditPriceList', parameters)
    },
    branch: {
      getBranches: parameters => Http('get', 'Branch', 'Get', parameters),
      getBranchById: parameters => Http('get', 'Branch', 'GetById', parameters),
      addBranch: parameters => Http('post', 'Branch', 'Add', parameters),
      updateBranch: parameters => Http('put', 'Branch', 'Edit', parameters),
      deleteBranch: parameters => Http('put', 'Branch', 'Delete', parameters)
    },
    request: {
      getRequests: parameters => Http('get', 'Request', 'Get', parameters),
      getRequestById: parameters =>
        Http('get', 'Request', 'GetById', parameters),
      addRequest: parameters => Http('post', 'Request', 'Add', parameters),
      updateRequest: parameters => Http('put', 'Request', 'Edit', parameters),
      deleteRequest: parameters => Http('put', 'Request', 'Delete', parameters),
      updateRequestFlag: parameters =>
        Http('put', 'Request', 'UpdateFlag', parameters),
      getStudentList: parameters =>
        Http('get', 'Request', 'GetStudentList', parameters),
      editStudentList: parameters =>
        Http('put', 'Request', 'EditStudentList', parameters),
      getCandidateList: parameters =>
        Http('get', 'Request', 'GetCandidateList', parameters),
      editCandidateList: parameters =>
        Http('put', 'Request', 'EditCandidateList', parameters)
    },
    candidate: {
      getCandidates: parameters => Http('get', 'Candidate', 'Get', parameters),
      getCandidateById: parameters =>
        Http('get', 'Candidate', 'GetById', parameters),
      addCandidate: parameters => Http('post', 'Candidate', 'Add', parameters),
      updateCandidate: parameters =>
        Http('put', 'Candidate', 'Edit', parameters),
      deleteCandidate: parameters =>
        Http('put', 'Candidate', 'Delete', parameters),
      addToGroup: parameters =>
        Http('post', 'Candidate', 'AddToGroup', parameters),
    },
    group: {
      getGroups: parameters => Http('get', 'Group', 'Get', parameters),
      getGroupById: parameters => Http('get', 'Group', 'GetById', parameters),
      addGroup: parameters => Http('post', 'Group', 'Add', parameters),
      updateGroup: parameters => Http('put', 'Group', 'Edit', parameters),
      deleteGroup: parameters => Http('put', 'Group', 'Delete', parameters),
      getTeacherList: parameters =>
        Http('get', 'Group', 'GetTeacherList', parameters),
      editTeacherList: parameters =>
        Http('put', 'Group', 'EditTeacherList', parameters),
      getStudentList: parameters =>
        Http('get', 'Group', 'GetStudentList', parameters),
      editStudentList: parameters =>
        Http('put', 'Group', 'EditStudentList', parameters),
      getPaymentList: parameters =>
        Http('get', 'Group', 'GetPaymentList', parameters),
      editPaymentList: parameters =>
        Http('put', 'Group', 'EditPaymentList', parameters),
      getClassList: parameters =>
        Http('get', 'Group', 'GetClassList', parameters),
      editClassList: parameters =>
        Http('put', 'Group', 'EditClassList', parameters)
    },
    student: {
      getStudents: parameters => Http('get', 'Student', 'Get', parameters),
      getStudentById: parameters =>
        Http('get', 'Student', 'GetById', parameters),
      addStudent: parameters => Http('post', 'Student', 'Add', parameters),
      updateStudent: parameters => 
        Http('put', 'Student', 'Edit', parameters),
      deleteStudent: parameters => 
        Http('put', 'Student', 'Delete', parameters),
      getActiveStudents: parameters =>
        Http('get', 'Student', 'GetActiveStudents', parameters),
      moveToGroup: parameters =>
        Http('post', 'Student', 'MoveToGroup', parameters),
      transferToGroup: parameters =>
        Http('post', 'Student', 'TransferToGroup', parameters),
      getPaymentList: parameters =>
        Http('get', 'Student', 'GetPaymentList', parameters),
      editPaymentList: parameters =>
        Http('put', 'Student', 'EditPaymentList', parameters),
      getGroupList: parameters =>
        Http('get', 'Student', 'GetGroupList', parameters),
      editGroupList: parameters =>
        Http('put', 'Student', 'EditGroupList', parameters)
    },
    teacher: {
      getTeachers: parameters => Http('get', 'Teacher', 'Get', parameters),
      getTeacherById: parameters =>
        Http('get', 'Teacher', 'GetById', parameters),
      addTeacher: parameters => Http('post', 'Teacher', 'Add', parameters),
      updateTeacher: parameters => Http('put', 'Teacher', 'Edit', parameters),
      deleteTeacher: parameters => Http('put', 'Teacher', 'Delete', parameters)
    },
    subject: {
      getSubjects: parameters => Http('get', 'Subject', 'Get', parameters),
      getSubjectById: parameters =>
        Http('get', 'Subject', 'GetById', parameters),
      addSubject: parameters => Http('post', 'Subject', 'Add', parameters),
      updateSubject: parameters => Http('put', 'Subject', 'Edit', parameters),
      deleteSubject: parameters => Http('put', 'Subject', 'Delete', parameters)
    },
    class: {
      getClasses: parameters => Http('get', 'Class', 'Get', parameters),
      getClassById: parameters => Http('get', 'Class', 'GetById', parameters),
      addClass: parameters => Http('post', 'Class', 'Add', parameters),
      updateClass: parameters => Http('put', 'Class', 'Edit', parameters),
      deleteClass: parameters => Http('put', 'Class', 'Delete', parameters),
      getParticipation: parameters =>
        Http('get', 'Class', 'GetParticipation', parameters),
      editParticipation: parameters =>
        Http('put', 'Class', 'EditParticipation', parameters)
    },
    examType: {
      getExamTypes: parameters => Http('get', 'ExamType', 'Get', parameters),
      getExamTypeById: parameters =>
        Http('get', 'ExamType', 'GetById', parameters),
      addExamType: parameters => Http('post', 'ExamType', 'Add', parameters),
      updateExamType: parameters => Http('put', 'ExamType', 'Edit', parameters),
      deleteExamType: parameters => Http('put', 'ExamType', 'Delete', parameters)
    },
    exam: {
      getExams: parameters => Http('get', 'Exam', 'Get', parameters),
      getExamById: parameters => Http('get', 'Exam', 'GetById', parameters),
      addExam: parameters => Http('post', 'Exam', 'Add', parameters),
      updateExam: parameters => Http('put', 'Exam', 'Edit', parameters),
      deleteExam: parameters => Http('put', 'Exam', 'Delete', parameters),
      getSubjects:parameters=>Http('get','Exam','GetSubjectList',parameters),
      getGroups:parameters=>Http('get','Exam','GetGroupList',parameters),
      getParticipation: parameters =>
        Http('get', 'Exam', 'GetParticipation', parameters),
      editParticipation: parameters =>
        Http('put', 'Exam', 'EditParticipation', parameters),
      getParticipantPool: parameters =>
        Http('get', 'Exam', 'GetParticipantPool', parameters)
    },
    payment: {
      getPayments: parameters => Http('get', 'Payment', 'Get', parameters),
      getPaymentById: parameters =>
        Http('get', 'Payment', 'GetById', parameters),
      addPayment: parameters => Http('post', 'Payment', 'Add', parameters),
      updatePayment: parameters => Http('put', 'Payment', 'Edit', parameters),
      deletePayment: parameters => Http('put', 'Payment', 'Delete', parameters),
    },
    expense: {
      getExpenses: parameters => Http('get', 'Expense', 'Get', parameters),
      getExpenseById: parameters =>
        Http('get', 'Expense', 'GetById', parameters),
      addExpense: parameters => Http('post', 'Expense', 'Add', parameters),
      updateExpense: parameters => Http('put', 'Expense', 'Edit', parameters),
      deleteExpense: parameters => Http('put', 'Expense', 'Delete', parameters),
    },
    dashboard: {
      getDashboardInfo: parameters =>
        Http('get', 'Dashboard', 'GetDashboardInfo', parameters)
    },
    report: {
      getCashFlowReport: parameters =>
        Http('get', 'Report', 'GetCashFlowReport', parameters)
    },
    setting: {
      getSettings: parameters => Http('get', 'Setting', 'Get', parameters),
      getSettingById: parameters =>
        Http('get', 'Setting', 'GetById', parameters)
    },
    status: {
      getStatuses: parameters => Http('get', 'Status', 'Get', parameters)
    },
    listOption: {
      getListOptions: parameters => Http('get', 'ListOption', 'Get', parameters)
    },
    user: {
      getUsers: parameters => Http('get', 'User', 'Get', parameters),
      getUserById: parameters => Http('get', 'User', 'GetById', parameters),
      addUser: parameters => Http('post', 'User', 'Add', parameters),
      updateUser: parameters => Http('put', 'User', 'Edit', parameters),
      deleteUser: parameters => Http('put', 'User', 'Delete', parameters),
      changePassword: parameters =>
        Http('put', 'User', 'ChangePassword', parameters),
      getRoles: parameters => Http('get', 'Role', 'Get', parameters)
    },
    file: {
      getFile: async (path, fileName) => {
        let response = await axios.get(
          `${Variables.api_url}/GetUserFile/RequestAttachments/${path}`,
          {
            headers: {
              Authorization: `Bearer ${use.token()}`
            },
            responseType: 'blob'
          }
        )

        const href = window.URL.createObjectURL(response.data)

        const anchorElement = document.createElement('a')
        anchorElement.href = href
        anchorElement.download = fileName
        document.body.appendChild(anchorElement)
        anchorElement.click()
        document.body.removeChild(anchorElement)
        window.URL.revokeObjectURL(href)
        return response
      }
    },
    country: {
      getCountries: parameters => Http('get', 'Country', 'Get', parameters),
      getCountryById: parameters =>
        Http('get', 'Country', 'GetById', parameters)
    }
  }
}
